import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithub } from "@fortawesome/free-brands-svg-icons"
import { faLinkedin } from "@fortawesome/free-brands-svg-icons"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { motion } from 'framer-motion';
import { useState } from "react";
import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { faGhost } from "@fortawesome/free-solid-svg-icons"
import { faBarsStaggered } from "@fortawesome/free-solid-svg-icons"

export default function Header(){

    const [showMenu, setShowMenu] = useState(false)
    console.log(showMenu)
    const handleWork = () => {
        setShowMenu(false);
        const targetElement = document.getElementById("projects");
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
    }
    const handleTop = () => {
        setShowMenu(false);
        const targetElement = document.getElementById("top");
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
    }

        

    return (
        <header className="fixed w-[100%] z-[49]">
        {
            !showMenu
            &&        <section className="bg-[#10e956] w-[100%] h-[70px] flex flex-row items-center justify-end px-[20px]">
            
            <button onClick={() => {
                handleTop()
            }}>
<FontAwesomeIcon icon={faGhost} style={{color: "black", fontSize: "40px"}} />
            </button>
            
            <button  onClick={() => {
                    setShowMenu(true)
                }} className="text-[70px] flex flex-row items-center justify-end w-[100%] ">
                                    <FontAwesomeIcon icon={faBarsStaggered} style={{color: "black"}} 
                        className="text-[50px]"
                    />
                </button>
            
            

                    </section>
                        

                 
            
        }

        {
            showMenu &&  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className=" bg-[#10e956] h-[100%] w-[100%] z-50 fixed flex flex-col justify-between"
                    >
                    
                    <button className="flex flex-col items-end justify-center px-[20px] h-[10%]" onClick={() => {
                            setShowMenu(false)
                        }}>
                    <FontAwesomeIcon icon={faXmark} style={{color: "black"}} 
                        className="text-[80px]"
                    />
                    
                    </button>
                        
                        <section className="bg-[#1e2128] w-[100%] h-[35%] connect text-right text-[60px] flex flex-col px-[20px] text-[30px]">
                            <h1 onClick={() => {
                                setShowMenu(false)
                            }}>Home</h1>
                            <h1 
                            onClick={() => {
                                
                                handleWork()
                            }}
                            >Work</h1>
                            <a href="/images/resume.png" download>Resume</a>
                            
                            
                        </section>
                    
            <section className="flex self-end justify-self-end text-white expoSpace flex flex-col w-[100%] h-[55%]">
                <a 
                href="https://github.com/ibrahimSho31/" target="_blank"
                className="flex hover:opacity-70 text-[40px] h-[30%] text-[#d6d6d6] flex-row items-center justify-between bg-[#333] px-[20px]">
                    <h1>Github</h1>
                    <FontAwesomeIcon icon={faGithub} style={{color: "#d6d6d6"}} />
                </a>

                <a
                href="https://www.linkedin.com/in/ibrahim-shokoya-85a032258/" target="_blank" 
                className="flex hover:opacity-70 text-[40px] h-[30%] text-[#cce4f0] flex-row items-center justify-between px-[20px] bg-[#0077b5]">
                    <h1>LinkedIn</h1>
                    <FontAwesomeIcon icon={faLinkedin} style={{color: "#cce4f0"}} />
                </a>

                <a 
                href="https://twitter.com/tolani_is?s=21&t=5kREoGoxMqsgn4YGzJUj4g" target="_blank"
                className="flex hover:opacity-70 text-[40px] h-[30%] text-[#d6d6d6] flex-row items-center justify-between px-[20px] bg-[black]">
                    <h1>X</h1>
                    <FontAwesomeIcon icon={faXTwitter} style={{color: "#d6d6d6"}} />
                </a>

                <a className="flex flex-row items-center justify-center bg-[#10ba46] hover:opacity-70
            w-[100%] h-[40%] text-[#f5f5f5] text-[30px] cyborg uppercase"
            href="mailto:shokoyaomotolani@gmail.com"
            >
                <h1 className="pr-[20px]">send a mail</h1>
                <FontAwesomeIcon icon={faEnvelope} style={{color: "#d6d6d6"}} />
            </a>
            </section>

            
            
            
        
                    

                    </motion.div>
        }

        </header>

    )
}